import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const services = [
  { name: "Web Solution Services", path: "/web-solution" },
  {
    name: "Content Management System",
    path: "/content-management-system",
  },
  {
    name: "CRM, SCM and ERP Services",
    path: "/crm-scm-and-erp-services",
  },
  { name: "EAI Services", path: "/eai-services" },
  { name: "E-Commerce", path: "/e-commerce-services" },
  { name: "Mobile Application", path: "/mobile-application-services" },
  { name: "Technical Maintenance", path: "/technical-maintenance-services" },
  { name: "Application Migration", path: "/application-migration" },
  { name: "SEO Services", path: "/seo-services" },
];
const ServiceSide = () => {
  return (
    <div>
      <h2 className="font-semibold uppercase  text-lg">All SERVICES</h2>
      <div className=" w-20 h-1 bg-main  mb-2 rounded-full" />
      <div className="bg-[#ECF1F6] rounded p-4 shadow-md sticky top-20 w-full max-w-sm">
        {/* Header ECF1F6 */}
        <div className="flex items-center gap-1 mb-2">
          <div className="bg-gradient-to-b from-[#456789] to-[#1a2a3a] px-[6px] rounded-md">
            <FontAwesomeIcon icon={faList} className="text-white text-sm" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800">Services</h3>
        </div>

        {/* Services List */}
        <div className=" bg-white ">
          {services.map((service, index) => (
            <Link
              to={service.path}
              key={index}
              className="flex justify-between no-underline items-center px-3 py-[10px]  hover:bg-[#ECF1F6] transition-all duration-200 cursor-pointer text-sm font-medium text-gray-700"
            >
              <span>{service.name}</span>
              <FontAwesomeIcon icon={faAngleRight} className="text-main" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceSide;
